export const productsEnum = {
    BookingType: 1,
    OffersType: 2,
    OrdersType: 3,
    ServicesType: 5
}